import { SurchargePeriod } from "@/models/surcharge-period.model"
import { type IPurchaseSurchargePeriod } from "@/interfaces/api/purchase-surcharge-period.interface"
export class PurchaseSurchargePeriod extends SurchargePeriod implements IPurchaseSurchargePeriod {
  public static className = "PurchaseSurchargePeriod"
  public static verboseName = "Brandstoftoeslag inkoop"

  purchaseItem: string

  constructor(purchaseSurchargePeriod: IPurchaseSurchargePeriod) {
    super(purchaseSurchargePeriod)

    this.purchaseItem = purchaseSurchargePeriod.purchaseItem
  }
}
